const _excluded = ["onChange", "properties", "translationContext", "modelPrefix", "storeKey", "templates"];var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}import { connect } from 'react-redux';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

import { t } from "../../I18N";
import FormGroup from "../../DocumentForm/components/FormGroup";
import { getAggregationSuggestions } from "../actions/libraryActions";
import { selectTemplates } from "../../utils/coreSelectors";
import { withRouter } from 'react-router';
import rison from 'rison-node';
import DateFilter from "./DateFilter";
import NestedFilter from "./NestedFilter";
import NumberRangeFilter from "./NumberRangeFilter";
import SelectFilter from "./SelectFilter";
import TextFilter from "./TextFilter";

const optionUrl = (value, name, query) => {
  const q = rison.encode(_objectSpread(_objectSpread({},
  query), {}, {
    filters: _objectSpread(_objectSpread({}, query.filters), {}, { [name]: { values: [value] } }),
    from: 0,
    limit: 30,
    includeUnpublished: false,
    order: 'desc',
    sort: 'creationDate',
    unpublished: false,
    allAggregations: false }));


  return `/library/?q=${q}`;
};

const prepareOptions = (property, location) => {
  const { q = '(filters:())' } = location.query;

  const query = rison.decode(q);
  const filteredProperty = _objectSpread(_objectSpread({},
  property), {}, {
    options: property.options.filter((option) => option.id !== 'any') });

  return filteredProperty.options.map((option) => {
    const finalTranslatedOption = _objectSpread(_objectSpread({},
    option), {}, {
      label:
      option.id === 'missing' ?
      t('System', 'No Label', undefined, false) :
      t(filteredProperty.content, option.label, undefined, false),
      url: optionUrl(option.value, property.name, query) });


    if (option.options) {
      const translatedSubOptions = option.options.map((subOption) => _objectSpread(_objectSpread({},
      subOption), {}, {
        label: t(filteredProperty.content, subOption.label, undefined, false),
        url: optionUrl(subOption.value, property.name, query) }));

      finalTranslatedOption.options = translatedSubOptions;
    }

    return finalTranslatedOption;
  });
};

const FiltersFromProperties = (_ref) => {let {
      onChange,
      properties,
      translationContext,
      modelPrefix = '',
      storeKey,
      templates

    } = _ref,props = _objectWithoutProperties(_ref, _excluded);return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    properties.map((property) => {var _property$inherit;
      const { type } = (_property$inherit = property.inherit) !== null && _property$inherit !== void 0 && _property$inherit.property ? property.inherit : property;

      const commonProps = {
        model: `.filters${modelPrefix}.${property.name}`,
        label: t(translationContext, property.label),
        onChange
      };

      const propertyOptions = property.options ? prepareOptions(property, props.location) : [];

      let filter = /*#__PURE__*/React.createElement(TextFilter, commonProps);

      switch (type) {
        case 'numeric':
          filter = /*#__PURE__*/React.createElement(NumberRangeFilter, commonProps);
          break;

        case 'select':
        case 'multiselect':
        case 'relationship':
          filter = /*#__PURE__*/
          React.createElement(SelectFilter, _extends({},
          commonProps, {
            lookup: getAggregationSuggestions.bind(null, storeKey, property.name),
            options: propertyOptions,
            prefix: property.name,
            showBoolSwitch: property.type === 'multiselect' || property.type === 'relationship',
            sort: property.type === 'relationship',
            totalPossibleOptions: propertyOptions.length,
            allowSelectGroup: true }));


          break;

        case 'nested':
          filter = /*#__PURE__*/
          React.createElement(NestedFilter, _extends({}, commonProps, { property: property, aggregations: props.aggregations }));

          break;

        case 'date':
        case 'multidate':
        case 'multidaterange':
        case 'daterange':
          filter = /*#__PURE__*/React.createElement(DateFilter, _extends({}, commonProps, { format: props.dateFormat }));
          break;

        default:
          break;}


      return /*#__PURE__*/_jsx(FormGroup, {}, property.name, filter);
    })));};



FiltersFromProperties.defaultProps = {
  onChange: () => {},
  dateFormat: '',
  modelPrefix: '',
  translationContext: ''
};













export function mapStateToProps(state, props) {
  return {
    dateFormat: state.settings.collection.get('dateFormat'),
    aggregations: state[props.storeKey].aggregations,
    storeKey: props.storeKey,
    templates: selectTemplates(state)
  };
}

export { FiltersFromProperties };
export default connect(mapStateToProps)(withRouter(FiltersFromProperties));